import { useCallback, useRef, type MutableRefObject, type Ref } from "react";
import { scrollCanvasControl } from "./canvasNavigationTarget";

/** A native listener is required because React's wheel listeners may be passive. */
export function useCanvasControlScroll<T extends HTMLElement>(forwardedRef?: Ref<T>) {
  const root = useRef<T | null>(null);
  return useCallback((element: T | null) => {
    root.current?.removeEventListener("wheel", scrollCanvasControl, true);
    root.current = element;
    element?.addEventListener("wheel", scrollCanvasControl, { capture: true, passive: false });
    if (typeof forwardedRef === "function") forwardedRef(element);
    else if (forwardedRef) (forwardedRef as MutableRefObject<T | null>).current = element;
  }, [forwardedRef]);
}
